import React from 'react';
import KitLandingLayout from './KitLandingLayout';

const config = {
  slug: 'autobot',
  name: 'AutoBot',
  breadcrumb: 'Kit AutoBot',
  industry: 'concesionarias y venta de vehículos',
  seoTitle: 'AutoBot — Chatbot WhatsApp para Concesionarias',
  seoDescription: 'Catálogo, cotizaciones y reserva de prueba de manejo por WhatsApp. El asistente IA para concesionarias de autos.',
  accent: 'indigo',
  accentHex: '#4F46E5',
  heroEmoji: '🚗',
  title: 'AutoBot — tu concesionaria vende desde WhatsApp',
  tagline:
    'Tus clientes exploran el catálogo, reciben cotizaciones y reservan una prueba de manejo directamente por WhatsApp. Sin llamadas, sin formularios, sin esperas.',
  stats: [
    { value: '24/7', label: 'atención automática' },
    { value: '0', label: 'llamadas para cotizar' },
    { value: '∞', label: 'autos en catálogo' },
  ],
  features: [
    { title: 'Catálogo de stock', body: 'Inventario completo con año, precio, kilometraje y link a las fotos.' },
    { title: 'Búsqueda por filtros', body: 'Marca, modelo, año, precio — todo desde el chat.' },
    { title: 'Cotización instantánea', body: 'Ficha técnica y precio en el mismo mensaje, sin esperar.' },
    { title: 'Reserva de prueba de manejo', highlight: true, body: 'El cliente elige fecha y hora, confirma en Google Calendar y recibe recordatorio automático.' },
    { title: 'Opciones de financiamiento', body: 'Pie, cuotas estimadas y condiciones de crédito en la conversación.' },
    { title: 'Contacto directo', body: 'El cliente puede pedir hablar con un ejecutivo en cualquier momento.' },
  ],
  flowSubtitle: 'Del interés a la prueba de manejo en 5 pasos.',
  flow: [
    { title: 'Escribe a WhatsApp', body: 'AutoBot se presenta y muestra las opciones disponibles.' },
    { title: 'Filtra y explora el stock', body: 'Ficha técnica + link a fotos del auto que le interesa.' },
    { title: 'Recibe cotización al instante', body: 'Precio, financiamiento estimado y pie mínimo — todo en el chat.' },
    { title: 'Reserva prueba de manejo', highlight: true, body: 'Fecha y hora reales del calendario, con confirmación + recordatorio automático.' },
    { title: 'El cliente llega listo para decidir', body: 'Ya vio el auto, sabe el precio y las condiciones de compra.' },
  ],
  mockup: {
    left: {
      title: 'Stock activo',
      subtitle: 'Última actualización: hoy',
      rows: [
        { primary: 'Toyota Corolla 2022 — $12.900.000', secondary: '45.000 km · Sedán · Automático', status: 'Disponible', link: 'Ver fotos' },
        { primary: 'Chevrolet Sail 2023 — $8.500.000', secondary: '28.000 km · Sedán · Manual', status: 'Reservado', link: 'Ver fotos' },
        { primary: 'Kia Sportage 2021 — $16.200.000', secondary: '62.000 km · SUV · Automático', status: 'En prueba', link: 'Ver fotos' },
        { primary: 'Nissan Versa 2024 — $11.400.000', secondary: '12.000 km · Sedán · Automático', status: 'Disponible', link: 'Ver fotos' },
      ],
    },
    right: {
      title: 'Agenda de pruebas — hoy',
      action: 'Ver calendario completo',
      rows: [
        { primary: '10:30 — Carlos Muñoz', secondary: 'Toyota Corolla 2022', badge: 'Confirmado' },
        { primary: '12:00 — Andrea Pérez', secondary: 'Kia Sportage 2021', badge: 'En camino' },
        { primary: '15:15 — Rodrigo Silva', secondary: 'Chevrolet Sail 2023', badge: 'Confirmado' },
        { primary: '17:00 — Valentina Rojas', secondary: 'Nissan Versa 2024', badge: 'Pendiente' },
      ],
    },
  },
  useCases: [
    'Concesionarias grandes',
    'Concesionarias medianas',
    'Ventas de autos usados',
    'Agencias multimarca',
  ],
};

export default function AutoBotKitPage() {
  return <KitLandingLayout config={config} />;
}
